import { Injectable, inject } from '@angular/core';
import { SiteApiService } from '@core/api/site-api.service';
import { Store } from '@ngrx/store';
import { StoreInitService } from '@dashboard/dashboard-library/helpers/store-init.service';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import {
  SetSelectedVesselAction,
  VesselsSelector,
} from '@dashboard/dashboard-store';
import { firstValueFrom } from 'rxjs';
import { RouteIds } from '@dashboard/dynamic-dashboards.route';

@Injectable()
export class VesselWrapperResolverService {
  private _store = inject(Store);

  async resolve(route: ActivatedRouteSnapshot): Promise<void> {
    const vesselImo = route.paramMap.get(RouteIds.vesselImo);

    const vessels = await firstValueFrom(this._store.select(VesselsSelector));
    const vesselId = vessels.find((v) => v.slug === vesselImo)?._id;
    this._store.dispatch(SetSelectedVesselAction({ vesselId }));

    return Promise.resolve();
  }
}
